import React from "react";
import RecipeForm from "./RecipeForm";

const AddRecipes = () => {
  return (
    <div>
      <RecipeForm />
    </div>
  );
};

export default AddRecipes;
